import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import UploadIcon from "../../../../../../assets/images/svgs/cloud-upload-brand-logo.svg";
import ImageUploader from "../../../../../../components/common/ImageUploader/ImageUploader";
import useImageUtils from "../../../../../../utils/useImageUtils";
import AdjustFramePopup from "./AdjustFramePopup/AdjustFramePopup";
import styles from "./VideoEditingInputFrames.module.scss";

const VideoEditingInputFrames = () => {
	const { t } = useTranslation("translation", { keyPrefix: "videoEditing.config.inputFrames" });
	const { getAspectRatioFromFile } = useImageUtils();
	const [firstFrame, setFirstFrame] = useState<File>();
	const [_lastFrame, setLastFrame] = useState<File>();
	const [frameToAdjust, setFrameToAdjust] = useState<File>();

	const validateAspectRatio = async (file: File) => (await getAspectRatioFromFile(file)) === "16:9";

	const uploadFirstFrame = async (e: ChangeEvent<HTMLInputElement>) => {
		const file = e.target?.files?.[0];
		if (file) {
			setFirstFrame(file);
			if (await validateAspectRatio(file)) {
			} else {
				setFrameToAdjust(file);
			}
		}
	};

	const uploadLastFrame = async (e: ChangeEvent<HTMLInputElement>) => {
		const file = e.target?.files?.[0];
		if (file) {
			if (await validateAspectRatio(file)) {
				setLastFrame(file);
			} else {
				setFrameToAdjust(file);
			}
		}
	};

	const deleteFirstFrame = async () => setFirstFrame(undefined);
	const deleteLastFrame = async () => setLastFrame(undefined);

	return (
		<>
			<Box className={styles.inputFrames}>
				<ImageUploader
					icon={<img className={styles.bigFrameEmptyIcon} src={UploadIcon} />}
					className={styles.inputFrame}
					emptyStateClassName={styles.bigEmpty}
					description={t("firstFrame.description")}
					titleClassName={styles.bigEmptyTitle}
					descriptionClassName={styles.bigEmptyDesc}
					onUpload={uploadFirstFrame}
					onDelete={deleteFirstFrame}
				/>
				{firstFrame && (
					<ImageUploader
						icon={<img className={styles.smallFrameEmptyIcon} src={UploadIcon} />}
						className={styles.inputFrame}
						emptyStateClassName={styles.smallEmpty}
						description={t("lastFrame.description")}
						titleClassName={styles.smallEmptyTitle}
						descriptionClassName={styles.smallEmptyDesc}
						onUpload={uploadLastFrame}
						onDelete={deleteLastFrame}
						optional
						supportedFilesText=" "
					/>
				)}
			</Box>
			{!!frameToAdjust && (
				<AdjustFramePopup
					open={!!frameToAdjust}
					imageUrl={URL.createObjectURL(frameToAdjust)}
					onClose={() => setFrameToAdjust(undefined)}
				/>
			)}
		</>
	);
};

export default observer(VideoEditingInputFrames);
